
import { Mixins, Component } from "vue-property-decorator";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';

// 舌诊报告配置相关API
import { getTongueComprehensiveSuggestionList, saveTongueComprehensiveSuggestionBatch } from "@/api/tongue";

@Component({ name: 'prescription-db-tongueReportConfig', components: { ETable } })
export default class TongueReportConfig extends Mixins(loading, Resize) {
    // 从路由获取品牌方名称和ID
    brandName = (this.$route.query.brandName as string) || "";
    merchantId = (this.$route.query.merchantId as string) || "";

    // 表格列配置（对应接口返回字段）
    columns = [
        { prop: "presSymptomName", label: "舌诊症状", minWidth: "120" },
        { prop: "comprehensiveSuggestion", label: "综合建议", minWidth: "250" },
        { prop: "updateBy", label: "最后操作人", minWidth: "100" },
        { prop: "updateTime", label: "最后操作时间", minWidth: "160" },
        { prop: "action", label: "操作", minWidth: "140", fixed: "right" },
    ];

    tableData: any[] = [];

    // 弹窗相关
    dialogVisible = false;
    formData = {
        id: null as any,
        comprehensiveSuggestion: ""
    }
    currentRow: any = null;

    mounted() {
        this.getData();
        this.windowResize(200);
    }

    /**
     * 获取列表数据（不分页）
     */
    getData() {
        if (!this.merchantId) return;
        this.showLoading();
        getTongueComprehensiveSuggestionList(this.merchantId).then((res: any) => {
            this.tableData = res.data || [];
        }).finally(() => {
            this.hideLoading();
        });
    }

    /**
     * 打开综合建议配置弹窗
     */
    handleConfig(row: any) {
        this.currentRow = row;
        this.formData = {
            id: row.id,
            comprehensiveSuggestion: row.comprehensiveSuggestion || ""
        };
        this.dialogVisible = true;
    }

    /**
     * 关闭弹窗
     */
    dialogClose() {
        this.dialogVisible = false;
        this.formData = { id: null, comprehensiveSuggestion: "" };
        this.currentRow = null;
    }

    /**
     * 表头样式（居中）
     */
    headerCellStyle() {
        return { background: '#F8F9FA', color: '#1A1A1C', textAlign: 'center' }
    }

    /**
     * 单元格样式（居中）
     */
    cellStyle() {
        return { textAlign: 'center' }
    }

    /**
     * 保存综合建议
     */
    handleSave() {
        if (!this.formData.comprehensiveSuggestion.trim()) {
            this.$message.warning("请输入综合建议");
            return;
        }
        this.showLoading();
        // 批量接口格式，单条修改时只传一条数据
        const params = {
            items: [{
                id: this.formData.id,
                comprehensiveSuggestion: this.formData.comprehensiveSuggestion
            }]
        }
        saveTongueComprehensiveSuggestionBatch(params).then(() => {
            this.$message.success("保存成功");
            this.dialogClose();
            this.getData();
        }).finally(() => {
            this.hideLoading();
        });
    }
}
